import { css, Interpolation, Theme } from '@emotion/react'

export const patientBox: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const patientBoxWrapper = (displayOnTop: boolean) =>
  css`
    ${displayOnTop &&
    css`
      order: -1;
    `}
  `

export const additionalFields = css`
  display: flex;
  flex-direction: column;
`

export const field: Interpolation<Theme> = css`
  margin-top: 24px;
`

export const description = (theme: Theme) => css`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
  margin-top: 8px;
`

export const tableFieldsSection: Interpolation<Theme> = css`
  margin-top: 24px;
`

export const tableFieldsCheckboxes: Interpolation<Theme> = css`
  display: flex;
  flex-direction: row;
  gap: 24px;
  flex-wrap: wrap;
`

export const tableFieldCheckbox: Interpolation<Theme> = css`
  margin-top: 0;
`

export const tableFieldsTabs: Interpolation<Theme> = css`
  margin-top: 24px;
`

export const tableFieldContent: Interpolation<Theme> = css`
  width: 100%;
  overflow-x: auto;
`
